/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getIdentityRegionaleEditiqueActions, {
    getIdentityRegionaleEditiqueTypes,
} from '../../../redux/editique/getIdentityRegionaleEditique'
import { Get } from '../../../serveur/axios'

function* getIdentityRegionaleEditiqueSagas({ response }) {
    const { governorate } = response

    let url = `/editique/identity_regional?`

    if (governorate) {
        url = `${url}&governorate=${governorate}`
    }

    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getIdentityRegionaleEditiqueActions.getIdentityRegionaleEditiqueSuccess(
                        { data: res.data.data, total: res.data.total }
                    )
                ),
            ])
        } else {
            yield put(
                getIdentityRegionaleEditiqueActions.getIdentityRegionaleEditiqueFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(
            getIdentityRegionaleEditiqueActions.getIdentityRegionaleEditiqueFailure(
                error
            )
        )
    }
}

export function* getIdentityRegionaleEditiqueSaga() {
    yield takeLatest(
        getIdentityRegionaleEditiqueTypes.GET_IDENTITY_REGIONALE_EDITIQUE_REQUEST,
        getIdentityRegionaleEditiqueSagas
    )
}
